import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { groupPolicyProviders } from '@services/api'
import { StoreExt } from '@utils/reactExt'

export class Providers extends StoreExt {
    @observable list = []
    @observable pairList = []
    @observable nameList = {}
    @observable selectedId = null
    @observable value = undefined

    @action
    getProviders = async () => {
        const providers = await groupPolicyProviders.pairList()
        runInAction(() => {
            this.pairList = providers.data.pairList
            this.nameList = providers.data.nameList
            this.list = providers.data.list
        })
        return providers
    }

    @action
    setSelected = async () => {
        if (this.pairList[this.value]) {
            this.selectedId = this.pairList[this.value]
        }
    }

    @action
    setValue = async value => {
        this.value = value
    }

    @action
    resetSelected = async () => {
        this.selectedId = null
        this.value = undefined
    }
}

export default remotedev(new Providers())
